export default __webpack_public_path__ + "static/media/new-user-icon.2046bb7b.svg";